import { render, staticRenderFns } from "./old_msntt_transfer_mgr.vue?vue&type=template&id=559f9b53&"
import script from "./old_msntt_transfer_mgr.vue?vue&type=script&lang=js&"
export * from "./old_msntt_transfer_mgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports